module.exports = __webpack_public_path__ + "img/mass-production-3.9d8c2007.png";